export const SERVICE_TYPES = "SERVICE_TYPES";
export const TRUCK_MANUFACTURERS = "TRUCK_MANUFACTURERS";
export const TRAILER_MANUFACTURERS = "TRAILER_MANUFACTURERS";
export const TRAILER_TYPES = "TRAILER_TYPES";
export const PAYMENT_TYPES = "PAYMENT_TYPES";
